import { useCallback } from 'react';

import { ColorDisplayOption, MultiColorDisplayOption } from '@vestico/model';

import { GridSelect } from './GridSelect';
import { MultiColorSelectOption } from './MultiColorSelectOption';
import { SingleColorSelectOption } from './SingleColorSelectOption';

export interface ColorSelectProps {
  options: ColorDisplayOption[] | MultiColorDisplayOption[];
  selectedOptionIndex?: number;
  didUpdateConfig: (index: number) => void;
  errorText: string;
  showErrorIfNeeded: boolean;
  hideOptionTitles?: boolean;
}

export const ColorSelect = ({ options, selectedOptionIndex, didUpdateConfig, errorText, showErrorIfNeeded, hideOptionTitles }: ColorSelectProps) => {
  const onConfigUpdate = useCallback((index: number) => () => didUpdateConfig(index), [didUpdateConfig]);

  const optionsMarkup = options.map((value, index) =>
    'hexColor' in value ? (
      <SingleColorSelectOption
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        option={value as ColorDisplayOption}
        selected={index === selectedOptionIndex}
        didUpdateConfig={onConfigUpdate(index)}
        hideTitle={hideOptionTitles}
      />
    ) : (
      <MultiColorSelectOption
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        option={value as MultiColorDisplayOption}
        selected={index === selectedOptionIndex}
        didUpdateConfig={onConfigUpdate(index)}
        hideTitle={hideOptionTitles}
      />
    )
  );

  return (
    <GridSelect selectedOptionIndex={selectedOptionIndex} errorText={errorText} showErrorIfNeeded={showErrorIfNeeded} itemsPerRowMobile={2}>
      {optionsMarkup}
    </GridSelect>
  );
};
